import { ILayoutContext, WithLayout } from "@Quiz/layout"
import QuizEmbedInfoContext, { EMBED_HOSTS, EMBED_INFO_CONTEXT_MAGAZIN, EMBED_INFO_CONTEXT_SZ_ON_SEPARATE_PAGE, EmbedHost, IQuizEmbedInfoContext } from "@Quiz/QuizEmbedInfoContext"
import SetQuizLayoutClasses from "@Quiz/SetQuizLayoutClasses"
import React, { PropsWithChildren, useEffect, useMemo, useState } from "react"
import { useMediaQuery } from "react-responsive"
import PickOne from "./PickOne"

const EmbedHostAndColorModeSwitcher: React.FC<PropsWithChildren> = ({ children }) => {
  const nativeIsDarkMode = useMediaQuery({ query: "(prefers-color-scheme: dark)" })
  const [ mode, setMode ] = useState<ILayoutContext["mode"]>(nativeIsDarkMode ? "dark" : "light")
  const [ embedHost, setEmbedHost ] = useState<EmbedHost>("sz-base")

  useEffect(() => { // update on browser change
    setMode(nativeIsDarkMode ? "dark" : "light")
  }, [nativeIsDarkMode])

  const embedInfo = useMemo<IQuizEmbedInfoContext>(() => {
    return embedHost === "sz-base"
      ? {
          ...EMBED_INFO_CONTEXT_SZ_ON_SEPARATE_PAGE,
          isEmbed: true,
        }
      : EMBED_INFO_CONTEXT_MAGAZIN
  }, [embedHost])

  return <QuizEmbedInfoContext.Provider value={embedInfo}>
    <WithLayout embedHost={embedHost} forceMode={mode} palletteId={embedInfo.colorPalettes.question[0]}>
      <PickOne
        label="Embed Host"
        items={EMBED_HOSTS.map((h) => ({val: h, key: h}))}
        change={(val) => setEmbedHost(val)}
        current={embedHost} />
      <PickOne
        label="Theme"
        items={[{val: "dark", key: "dark"}, {val: "light", key: "light"}]}
        change={(val) => setMode(val as ILayoutContext["mode"])}
        current={mode} />
      <div className={`sandbox__colormode sandbox__colormode--${mode}`}>
        <SetQuizLayoutClasses>
          {children}
        </SetQuizLayoutClasses>
      </div>
    </WithLayout>
  </QuizEmbedInfoContext.Provider>
}

export default EmbedHostAndColorModeSwitcher
